export enum FuelTypeEnum {
  FO = "fo",
  DIESEL = "diesel",
  FG = "fg",
  NG = "ng",
  LPG = "lpg",
}
